import { useTranslation } from "react-i18next";
import Input from "../components/common/Input";
import { useRef, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { fetchForgotNew } from "./FetchAuth";

const ForgotNew = () => {
  const [state, setState] = useState("normal");

  const { t } = useTranslation();
  const { tk } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const confirmPasswordRef = useRef(null);

  const resetErrors = () => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      password: "",
      confirmPassword: "",
    }));

    setStatePassword("normal");
    setStateConfirmPassword("normal");
  };

  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const [statePassword, setStatePassword] = useState(state);
  const [stateConfirmPassword, setStateConfirmPassword] = useState(state);

  //   const handleSubmit = (e) => {
  //     e.preventDefault();
  //     fetchForgotPassword(email).then((data) => {
  //       if (data.success) {
  //         setState("success");
  //     } else {
  //         setState("error");
  //         setErrorsEmail("Email not found")
  //     }
  //     });
  // }

  const handlePasswordChange = (e) => {
    // handle password change
    setPassword(e.target.value);
    resetErrors();

    if (e.target.value.length < 8) {
      // check if the password is at least 8 characters long
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must be at least 8 characters long."),
      }));
    } else if (!/[A-Z]/.test(e.target.value)) {
      // check if the password contains at least one capital letter
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must contain at least one capital letter."),
      }));
    } else if (!/[a-z]/.test(e.target.value)) {
      // check if the password contains at least one lowercase letter
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must contain at least one lowercase letter."),
      }));
    } else if (!/\d/.test(e.target.value)) {
      // check if the password contains at least one digit
      setStatePassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: t("The password must contain at least one digit."),
      }));
    }

    if (e.target.value !== confirmPassword && confirmPassword) {
      // check if the password matches the confirm password
      setStateConfirmPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: t("Passwords do not match."),
      }));
    }
  };

  const handleConfirmPasswordChange = (e) => {
    // handle confirm password change
    setConfirmPassword(e.target.value);
    resetErrors();
    if (e.target.value !== password) {
      // check if the confirm password matches the password
      setStateConfirmPassword("error");
      setErrors((prevErrors) => ({
        ...prevErrors,
        confirmPassword: t("Passwords do not match."),
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (confirmPassword === password) {
      fetchForgotNew(password, tk).then((data) => {
        if (data.success) {
          setState("success");
        } else {
          setState("error");
        }
      });
    } else if (confirmPassword !== password) {
      confirmPasswordRef.current.focus();
    }
  };

  if (state === "success") {
    return <Navigate to="/" />;
  }

  return (
    <div className="forgot-password">
      <h1>{t("Set new password")}</h1>
      <p className="paragraph">
        {t(
          "Please enter the email address associated with your account and we will email you a link to reset your password."
        )}
      </p>
      <form onSubmit={handleSubmit} className="forgot-password__form">
        <div className="form-default">
          <Input
            id="password"
            label={t("New password")}
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder={t("Enter new password")}
            state={statePassword}
            alertState={errors.password}
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
            required
            style={{ marginBottom: "12px" }}
          />
          <Input
            id="confirm-password"
            label={t("Confirm Password")}
            type="password"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            placeholder={t("Enter confirm password")}
            state={stateConfirmPassword}
            alertState={errors.confirmPassword}
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\\\\d)[A-Za-z\\\\d@$!%*?&-_{[}]]]{8,}$"
            required
            ref={confirmPasswordRef}
          />
        </div>

        <button className="form-default__submit mt-20" type="submit">
          {t("Reset Password")}
        </button>
        <Link className="back-to-sign-in" to="/sign-in">
          {t("Back to Log in")}
        </Link>
      </form>
    </div>
  );
};

export default ForgotNew;
